var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"theme":"base"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v(" We use cookies to ensure you get the best experience on our website. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }